import React from 'react';
import {assignIn, first, isArray, isEmpty, noop} from 'lodash';
import fieldByType from '../../../components/core/fields/fields-factory';
import {checkInFieldsByType} from '../../../constants/check-in-out';

const buildCheckInFields = (fieldsSet, options, state) => {
	const {
		handleFieldChange, save_errors, requestAutoComplete,
		showModal, hideModal,
		cleanAutoComplete, autocomplete
	} = options;

	return fieldsSet.map((fieldsRow, rowNumber) => {
		const classNames = 'col-xs-12', rowKey = `fields-row-${rowNumber}`;
		return (
			<div key={rowKey} className="row">
				{fieldsRow.map((field) => {
					const key = field.name,
						handleChange = handleFieldChange(field.name),
						errorMessages = isEmpty(save_errors[field.name]) ? '' :
							isArray(save_errors[field.name]) ? first(save_errors[field.name]) : save_errors[field.name],
						value = state[field.name],
						isAutoFill = field.type === 'auto-fill',
						displayText = isAutoFill ? state[field.textName] : '',
						handleTextChange = isAutoFill ? handleFieldChange(field.textName) : noop,
						errorWrapperClassNames = 'col-xs-12';

					const fieldProps = assignIn({}, field, {
						classNames,
						key,
						handleChange,
						handleTextChange,
						errorMessages,
						value,
						displayText,
						errorWrapperClassNames,
						requestAutoComplete,
						cleanAutoComplete,
						autocomplete,
						showModal,
						hideModal
					});
					return fieldByType(field.type, fieldProps, 'check-in');
				})}
			</div>
		);
	});
};

const checkInFields = (checkInType, options, state) => {
	return buildCheckInFields(checkInFieldsByType(checkInType), options, state);
};

export {checkInFields};